import {MetaReducer} from '@ngrx/store';
import {currentUserMetaReducer} from './current-user-meta.reducer';


export const userMetaReducers: MetaReducer[] = [currentUserMetaReducer];
